
namespace Gamification.Gamification {
    export class TipologieProdottiColumns {
        static columnsKey = 'Gamification.TipologieProdotti';
    }
}